"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpRequest = void 0;
function httpRequest(url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'text';
        xhr.withCredentials = true;
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 400) {
                resolve(xhr.responseText);
            }
            else {
                reject(new Error("Failed to load " + url + ", status " + xhr.status));
            }
        };
        xhr.onerror = function () { return reject(new Error("Failed to load " + url)); };
        xhr.send();
    });
}
exports.httpRequest = httpRequest;
//# sourceMappingURL=http-request.js.map